const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};

window.onWizzyScriptLoaded = function () {
  replaceTemplate("wizzy-autocomplete-topproducts");
  replaceTemplate("wizzy-search-results-product");
  replaceTemplate("wizzy-search-results");
  replaceTemplate("wizzy-search-wrapper");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      payload.forEach((item) => {
        item.attributes.forEach((attr) => {
          if (attr.id == "product_variant_prices") {
            if (attr.values.length > 1) {
              item.minVariantPrice = attr.values[0].value[0];
            }
          }
        });
        if (item.price) {
          item.price = parseInt(item.price.replace(/,/g, ""));
        }
        if (item.sellingPrice) {
          item.sellingPrice = parseInt(item.sellingPrice.replace(/,/g, ""));
        }
      });
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
      const element = document.querySelector(".collection-description");
      const heightDesktop = element ? element.offsetHeight + 1200 : 1200;
      const heightMobile = element ? element.offsetHeight + 3100 : 3100;

      wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
        desktop: heightDesktop,
        mobile:heightMobile
      };

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      const body = document.querySelector("body");
      if (body) {
        body.classList.add("wizzy-collection-element-hide");
      }
      return payload;
    }
  );
};

document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ JavaScript is running!");

  function getMetafieldsJSON() {
    let metafieldsElement = document.getElementById("wizzy-product-metafields");

    if (!metafieldsElement) {
      console.warn("⚠️ Retrying: Metafields JSON not found yet.");
      setTimeout(getMetafieldsJSON, 500);
      return;
    }

    let jsonText = metafieldsElement.getAttribute("data-json");

    try {
      let metafieldsData = JSON.parse(jsonText);
      console.log("✅ Valid JSON Parsed:", metafieldsData);
      updateProductLabels(metafieldsData);
    } catch (error) {
      console.error("❌ Error parsing JSON:", error);
    }
  }

  function updateProductLabels(metafieldsData) {
    let products = document.querySelectorAll(".wizzy-result-product");
    console.log(`🛍️ Found ${products.length} products`);

    products.forEach((product) => {
      let groupId = product.getAttribute("data-group-id"); // ✅ Get `data-group-id`

      if (!groupId) {
        console.warn("❌ Group ID missing!", product);
        return;
      }

      console.log(`🔍 Checking group ID: ${groupId}`);

      // Ensure group ID is a string to match JSON format
      let productMeta = metafieldsData.find(
        (p) => String(p.id) === String(groupId)
      );
      if (productMeta && productMeta.label) {
        console.log(
          `✅ Adding label "${productMeta.label}" to product with group ID ${groupId}`
        );

        // Fetch label container using product ID
        let labelContainer = product.querySelector(".custom-label-overlay");
        if (labelContainer) {
          labelContainer.innerHTML = `<span class="custom-label">${productMeta.label}</span>`; // ✅ Insert label text
          labelContainer.style.display = "block"; // Ensure it's visible
        } else {
          console.warn(
            `⚠️ No label container found for product with group ID="${groupId}"`
          );
        }
      } else {
        console.log(
          `❌ No label for product with group ID ${groupId}, skipping.`
        );
      }
    });
  }

  // Delay execution to allow Wizzy to load products
  setTimeout(() => {
    console.log("⏳ Waiting for Wizzy to render...");
    getMetafieldsJSON();
  }, 2000);

  // Watch for new product additions (for infinite scroll or AJAX)
  let observer = new MutationObserver(() => {
    console.log("🔄 Wizzy updated, checking products...");
    getMetafieldsJSON();
  });

  let targetNode = document.querySelector(".wizzy-search-results");
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
    console.log("👀 Watching for Wizzy updates...");
  } else {
    console.error("❌ Could not find .wizzy-search-results container.");
  }
});
